import { create } from "zustand";
import marketdata from "../data/Services/marketdata";

const CURRENT_POLL_ID = "poll-1";

// Master switch for the startup poll modal. Set false to disable the campaign
// (poll-1 encerrada) — keeps the store/server-persistence intact for the dashboard.
const POLL_ENABLED = false;

const usePollStore = create((set, get) => ({
  isVisible: false,
  hasVoted: false,
  currentPollId: CURRENT_POLL_ID,
  votes: [],
  isLoading: false,
  hasCheckedServer: false,

  showModal: () => set({ isVisible: true }),

  hideModal: () => set({ isVisible: false }),

  shouldShow: () => {
    if (!POLL_ENABLED) return false;
    const { hasVoted, hasCheckedServer } = get();
    if (!hasCheckedServer) return false;
    return !hasVoted;
  },

  loadFromServer: async () => {
    if (get().hasCheckedServer) return;

    set({ isLoading: true });
    try {
      const data = await marketdata.getPoll();
      if (data?.votes) {
        const alreadyVoted = data.votes.some(
          (v) => v.pollId === get().currentPollId,
        );
        console.log(
          `[PollStore] Loaded ${data.votes.length} votes, voted on ${get().currentPollId}: ${alreadyVoted}`,
        );
        set({
          votes: data.votes,
          hasVoted: alreadyVoted,
          hasCheckedServer: true,
          isLoading: false,
        });
      } else {
        console.log("[PollStore] No poll data found on server");
        set({ hasCheckedServer: true, isLoading: false });
      }
    } catch (error) {
      console.error("[PollStore] Failed to load poll from server:", error);
      set({ hasCheckedServer: true, isLoading: false });
    }
  },

  submitVote: async (choice) => {
    set({ isLoading: true });

    const newVote = {
      pollId: get().currentPollId,
      choice,
      date: new Date().toISOString(),
      userAgent: navigator.userAgent,
      screenSize: `${window.screen.width}x${window.screen.height}`,
    };

    const updatedVotes = [...get().votes, newVote];

    try {
      await marketdata.savePoll({ votes: updatedVotes });
      console.log(
        `[PollStore] Vote saved: ${choice} for ${get().currentPollId}`,
      );
    } catch (error) {
      console.error("[PollStore] Failed to save vote to server:", error);
    }

    set({
      votes: updatedVotes,
      hasVoted: true,
      isLoading: false,
    });
  },
}));

export default usePollStore;
